import PropTypes from "prop-types";
import * as React from "react";
import { Link } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { useInfluencers } from "../../../../hooks";
import { Influencer } from "../../../../domain";
import css from "./CompactThumbnails.module.css";

const enricher = (results) => results.map(Influencer.from);

function ThumbnailRow({ title, sectionName, variant }) {
  const { ref, inView } = useInView({ threshold: 0.01 });
  const { results } = useInfluencers(inView, sectionName, enricher);

  const imageClass =
    variant === "franchise" ? css.franchiseImage : css.characterImage;

  if (!results?.length) {
    return <div ref={ref} />;
  }

  return (
    <div ref={ref} className={css.row}>
      <h3 className={css.heading}>{title}</h3>

      <div className={css.track}>
        {results.map((item) => (
          <Link
            key={item.route}
            className={css.thumbnail}
            to={`/${item.route}`}
          >
            <img
              className={`${css.thumbnailImage} ${imageClass}`}
              src={item.avatarUrl || item.avatar_url}
              alt={item.name}
              loading="lazy"
              width={variant === "franchise" ? 80 : 72}
              height={variant === "franchise" ? 80 : 72}
            />
            <p className={css.label}>{item.name}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}

ThumbnailRow.propTypes = {
  title: PropTypes.string.isRequired,
  sectionName: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["franchise", "character"]).isRequired,
};

export default function CompactThumbnails() {
  return (
    <div className={css.wrapper}>
      <div className={css.section}>
        <div className={css.grid}>
          <ThumbnailRow
            title="Popular Franchises"
            sectionName="popularFranchises"
            variant="franchise"
          />
          <ThumbnailRow
            title="Beloved Characters"
            sectionName="popularCharacters"
            variant="character"
          />
        </div>
      </div>
    </div>
  );
}
